module.exports = __webpack_public_path__ + "img/task_comment@2x.766b0ca5.png";